import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // 定义状态
  state: {
    ip: 'https://www.njzhny.com:8443/micro-iot/',
    loginIp: 'https://www.njzhny.com:8443/'
    // ip: 'http://192.168.0.102:8009/'
  }
})



// WEBPACK FOOTER //
// ./src/store.js